// Existing app copy for discovery surfaces.
export const discoveryCopy = {
  ko: {
    'search.reason.anniversaryGeneric': '오늘 발매 기념일',
    'search.reason.anniversary': '오늘 발매 {{years}}주년',
    'common.cancel': '취소',
    'common.ad': '광고',
    'common.retry': '다시 시도',
    'common.close': '닫기',
    'home.accessibility': 'postpop 홈',
    'home.todayAlbum': '오늘의 앨범',
    'home.todayAlbumUnavailable': '오늘의 앨범을 확인하지 못했어요',
    'home.pullToRefresh': '화면을 아래로 당겨 다시 불러와 주세요.',
    'home.choosingAlbum': '오늘 보여드릴 앨범을 고르고 있어요',
    'home.choosingAlbumBody': '새로운 리뷰와 활동이 쌓이면 자동으로 다시 선정합니다.',
    'home.newDiscovery': '새로운 발견',
    'home.heroViewDetails': '포스트팝에서 자세히 보기',
    'home.dividedOpinion': '평가가 나뉜 앨범',
    'home.browseReviewers': '회원 둘러보기',
    'home.myArchive': '나의 음악 기록',
    'home.tracksForYou': '지금 들어볼 곡',
    'home.continueBrowsing': '이어서 둘러보기',
    'home.recentReviewCount': '최근 7일 리뷰 {{count}}개',
    'home.reviewCountRecorded': '리뷰 {{count}}개 기록',
    'home.newReview': '새 리뷰가 올라왔어요',
    'home.reviewerReason.similarTaste': '공통 평가 작품 {{count}}개',
    'home.reviewerReason.active': '활발한 회원',
    'home.reviewerReason.rising': '최근 활동 상승',
    'home.reviewerReason.discovery': '새로운 회원',
    'home.reviewerReason.recentReviews': '최근 7일 {{count}}개',
    'home.reviewerReason.reviewCount': '리뷰 {{count}}개',
    'home.reviewerReason.newReview': '새 회원',
    'home.todayNoReviewTitle': '아직 등록된 리뷰가 없어요',
    'home.todayNoReviewBody': '이 앨범의 첫 기록을 남겨보세요.',
    'home.firstReviewA11y': '{{title}} 첫 리뷰 남기기',
    'home.readReviewA11y': '{{name}}님의 리뷰 읽기',
    'home.reviewCount': '리뷰 {{count}}',
    'home.engagement': '공감 {{likes}} · 댓글 {{comments}}',
    'home.opinionWaitingTitle': '서로 다른 평가를 모으고 있어요',
    'home.opinionWaitingBody': '조건을 충족한 앨범을 불러오면 서로 다른 두 시선을 보여드릴게요.',
    'home.reason.firstReviewToday': '오늘 첫 리뷰가 등록됐어요',
    'home.reason.reviewReturned': '오랜만에 새 리뷰가 등록됐어요',
    'home.reason.noReviews': '아직 리뷰가 없어요',
    'home.reason.anniversary': '오늘 발매 {{years}}주년',
    'home.reason.savedUnrated': '저장했지만 아직 평가하지 않았어요',
    'home.reason.followedReview': '팔로우한 회원이 리뷰했어요',
    'home.reason.savedNewReview': '저장한 앨범에 새 리뷰가 달렸어요',
    'home.reason.weeklyGrowth': '이번 주 리뷰가 가장 많이 늘었어요',
    'home.reason.anniversaryGeneric': '오늘 발매 기념일을 맞은 앨범',
    'home.reason.recentReview': '회원이 최근 리뷰를 남긴 앨범',
    'home.discoveryReason.followedReview': '팔로잉 리뷰',
    'home.discoveryReason.savedNewReview': '저장 앨범 새 리뷰',
    'home.discoveryReason.similarListeners': '비슷한 취향의 추천',
    'home.discoveryReason.interestedEra': '관심 연대',
    'home.discoveryReason.recentRelease': '최근 발매',
    'home.trackReason.similarListeners': '비슷한 취향의 호평',
    'home.trackReason.similarListenersWithCount': '비슷한 취향 {{count}}명의 호평',
    'home.trackReason.interestedArtist': '관심 아티스트의 곡',
    'home.trackReason.interestedGenre': '관심 장르 추천',
    'home.trackReason.representative': '추천 앨범 수록곡',
    'home.trackReason.communityTop': '회원들의 호평',
    'home.trackReason.recentlyRising': '최근 호평 증가',
    'home.trackReason.earlyResponse': '소수 평가에서 호평',
    'home.discoveryReason.weeklyGrowth': '주간 리뷰 증가',
    'search.reason.coLiked': '취향이 비슷한 회원의 추천',
    'home.discovery.savedAlbum': '저장 앨범 기반',
    'common.noArtist': '아티스트 정보 없음',
    'home.discovery.postpop': '포스트팝 추천',
    'home.discovery.genreRating': '장르 평점 상위',
    'home.discovery.steadyReviews': '꾸준한 리뷰',
    'home.discovery.monthlyRelease': '이달의 신보',
    'home.discovery.followingReview': '팔로잉 리뷰',
    'home.discovery.newGenre': '새로운 장르',
    'search.discoverByTaste': '취향으로 발견하기',
    'search.discoverFromReviews': '리뷰에서 발견하기',
    'search.discoverFromPlaylists': '플리로 발견하기',
    'search.reason.similarListenersTrack': '취향이 비슷한 회원이 높게 평가',
    'search.reason.similarListenersTrackWithCount': '취향이 비슷한 회원 {{count}}명이 높게 평가',
    'search.reason.interestedArtistTrack': '관심 아티스트 앨범에서 고른 곡',
    'search.reason.interestedGenreTrack': '관심 장르에서 고른 곡',
    'search.reason.representativeTrack': '추천 앨범에서 먼저 들어볼 곡',
    'search.reason.postpopPickTrack': '포스트팝 추천곡',
    'search.reason.communityTopTrack': '회원들이 높게 평가한 곡',
    'search.reason.communityTopTrackWithRating': '★ {{rating}} · {{count}}명 평가',
    'search.reason.recentlyRisingTrack': '최근 좋은 평가가 늘고 있어요',
    'search.reason.earlyResponseTrack': '평가는 적지만 반응이 좋아요',
    'search.koreanMusic': '국내 음악',
    'search.internationalMusic': '해외 음악',
    'search.postpopPick': '포스트팝 추천',
    'search.worthExploring': '둘러볼 만한 앨범',
    'search.reason.highRating': '높게 평가한 앨범',
    'search.reason.interestedArtist': '관심 아티스트',
    'search.reason.interestedGenre': '관심 장르',
    'search.reason.similarListeners': '취향이 비슷한 회원의 추천',
    'search.reason.interestedEra': '관심 연대의 음악',
    'search.reason.interestedRegion': '국내·해외 취향에서 고른 음악',
    'search.reason.interestedDomestic': '취향에 맞는 국내 음악',
    'search.reason.interestedInternational': '취향에 맞는 해외 음악',
    'search.reviewBy': '리뷰 · {{user}}',
    'search.continueDiscovering': '이어서 발견하기',
    'search.browseByEra': '연대별 앨범 둘러보기',
    'search.allEras': '50년대부터 지금까지 한 번에',
    'search.moreArtistAlbums': '{{artist}}의 앨범 더 보기',
    'search.artistAlbums': '아티스트 앨범',
    'search.browseEraRegion': '{{decade}} {{region}} 앨범 둘러보기',
    'search.sameEraAsRecent': '최근 검색과 같은 시대',
    'search.sameEraAsInterest': '최근 관심과 같은 시대',
    'search.browsePostpopPicks': '포스트팝 추천 앨범 둘러보기',
    'search.findFromEditorial': '편집 추천에서 새로운 앨범 찾기',
    'search.findAlbumFromReviews': '리뷰에서 앨범 발견하기',
    'search.continueFromFanRecords': '회원들의 기록에서 이어보기',
    'search.region.kr': '국내',
    'search.region.global': '해외',
  },
  en: {
    'search.reason.anniversaryGeneric': 'Release anniversary today',
    'search.reason.anniversary': 'Released {{years}} years ago today',
    'common.cancel': 'Cancel',
    'common.ad': 'Ad',
    'common.retry': 'Try Again',
    'common.close': 'Close',
    'home.accessibility': 'Postpop Home',
    'home.todayAlbum': "Today's Album",
    'home.todayAlbumUnavailable': "We couldn't load today's album",
    'home.pullToRefresh': 'Pull down to try again.',
    'home.choosingAlbum': "We're choosing today's album",
    'home.choosingAlbumBody': 'It will update automatically as new reviews and activity come in.',
    'home.newDiscovery': 'New Discoveries',
    'home.heroViewDetails': 'View details on Postpop',
    'home.dividedOpinion': 'Divisive Album',
    'home.browseReviewers': 'Browse Members',
    'home.myArchive': 'My Music Log',
    'home.tracksForYou': 'Listen Now',
    'home.continueBrowsing': 'Keep Browsing',
    'home.recentReviewCount': '{{count}} reviews in the past 7 days',
    'home.reviewCountRecorded': '{{count}} reviews',
    'home.newReview': 'A New Review Was Posted',
    'home.reviewerReason.similarTaste': '{{count}} albums rated in common',
    'home.reviewerReason.active': 'Active member',
    'home.reviewerReason.rising': 'Rising member',
    'home.reviewerReason.discovery': 'New to you',
    'home.reviewerReason.recentReviews': '{{count}} in the past 7 days',
    'home.reviewerReason.reviewCount': '{{count}} reviews',
    'home.reviewerReason.newReview': 'New member',
    'home.todayNoReviewTitle': 'No reviews yet',
    'home.todayNoReviewBody': 'Be the first to rate or review this album.',
    'home.firstReviewA11y': 'Leave the first review for {{title}}',
    'home.readReviewA11y': 'Read {{name}}’s review',
    'home.reviewCount': '{{count}} reviews',
    'home.engagement': '{{likes}} likes · {{comments}} comments',
    'home.opinionWaitingTitle': 'Gathering different points of view',
    'home.opinionWaitingBody': 'When an album qualifies, two contrasting reviews will appear here.',
    'home.reason.firstReviewToday': 'Its first review arrived today',
    'home.reason.reviewReturned': 'A new review arrived after a long pause',
    'home.reason.noReviews': 'No reviews yet',
    'home.reason.anniversary': 'Released {{years}} years ago today',
    'home.reason.savedUnrated': 'Saved, but not rated yet',
    'home.reason.followedReview': 'Reviewed by someone you follow',
    'home.reason.savedNewReview': 'A saved album has a new review',
    'home.reason.weeklyGrowth': 'Getting the most new reviews this week',
    'home.reason.anniversaryGeneric': 'An album celebrating its release anniversary',
    'home.reason.recentReview': 'Recently reviewed by a member',
    'home.discoveryReason.followedReview': 'Reviewed by someone you follow',
    'home.discoveryReason.savedNewReview': 'New review on a saved album',
    'home.discoveryReason.similarListeners': 'Picks from similar listeners',
    'home.discoveryReason.interestedEra': 'An era you like',
    'home.discoveryReason.recentRelease': 'Recently released',
    'home.trackReason.similarListeners': 'Loved by similar listeners',
    'home.trackReason.similarListenersWithCount': 'Loved by {{count}} similar listeners',
    'home.trackReason.interestedArtist': 'An artist you like',
    'home.trackReason.interestedGenre': 'A genre you like',
    'home.trackReason.representative': 'From a recommended album',
    'home.trackReason.communityTop': 'Member favorite',
    'home.trackReason.recentlyRising': 'Recent ratings rising',
    'home.trackReason.earlyResponse': 'Promising early ratings',
    'home.discoveryReason.weeklyGrowth': 'Weekly review growth',
    'search.reason.coLiked': 'Loved by Members with Similar Taste',
    'home.discovery.savedAlbum': 'Based on your saved albums',
    'common.noArtist': 'Artist information unavailable',
    'home.discovery.postpop': 'Postpop Pick',
    'home.discovery.genreRating': 'Top-rated in this genre',
    'home.discovery.steadyReviews': 'Still drawing reviews',
    'home.discovery.monthlyRelease': 'New This Month',
    'home.discovery.followingReview': 'Reviewed by someone you follow',
    'home.discovery.newGenre': 'A new genre',
    'search.discoverByTaste': 'Based on Your Taste',
    'search.discoverFromReviews': 'Discover through Reviews',
    'search.discoverFromPlaylists': 'Discover through Playlists',
    'search.reason.similarListenersTrack': 'Rated highly by members with similar taste',
    'search.reason.similarListenersTrackWithCount':
      'Rated highly by {{count}} members with similar taste',
    'search.reason.interestedArtistTrack': 'A pick from an artist you’re into',
    'search.reason.interestedGenreTrack': 'Picked from a genre you enjoy',
    'search.reason.representativeTrack': 'A track to start with from a recommended album',
    'search.reason.postpopPickTrack': 'A Postpop pick',
    'search.reason.communityTopTrack': 'Highly rated by members',
    'search.reason.communityTopTrackWithRating': '★ {{rating}} · {{count}} ratings',
    'search.reason.recentlyRisingTrack': 'Recent ratings are rising',
    'search.reason.earlyResponseTrack': 'Early ratings are promising',
    'search.koreanMusic': 'Korean Music',
    'search.internationalMusic': 'Global Music',
    'search.postpopPick': 'Postpop Pick',
    'search.worthExploring': 'Worth Exploring',
    'search.reason.highRating': 'An Album You Rated Highly',
    'search.reason.interestedArtist': 'An Artist You Like',
    'search.reason.interestedGenre': 'A Genre You Like',
    'search.reason.similarListeners': 'Loved by Members with Similar Taste',
    'search.reason.interestedEra': 'From a Decade You Like',
    'search.reason.interestedRegion': 'From Your Korean and Global Music Taste',
    'search.reason.interestedDomestic': 'Korean Music for Your Taste',
    'search.reason.interestedInternational': 'Global Music for Your Taste',
    'search.reviewBy': 'Review · {{user}}',
    'search.continueDiscovering': 'Continue Discovering',
    'search.browseByEra': 'Browse Albums by Era',
    'search.allEras': 'From the 1950s to today',
    'search.moreArtistAlbums': 'More albums by {{artist}}',
    'search.artistAlbums': 'Artist albums',
    'search.browseEraRegion': 'Explore {{region}} albums from the {{decade}}',
    'search.sameEraAsRecent': 'From the same era as a recent search',
    'search.sameEraAsInterest': 'From an era you recently explored',
    'search.browsePostpopPicks': 'Browse Postpop Picks',
    'search.findFromEditorial': 'Find something new in our editorial picks',
    'search.findAlbumFromReviews': 'Discover Albums through Reviews',
    'search.continueFromFanRecords': 'Keep exploring through members’ reviews',
    'search.region.kr': 'Korean',
    'search.region.global': 'global',
  },
};
